import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { INTEGRATION_REATILS } from 'src/app/constants';
import { LanguageService } from 'src/app/services';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css']
})
export class IntegrationComponent implements OnInit {

  language: string;
  subscriptions: Subscription = new Subscription();
  retails = INTEGRATION_REATILS;


  constructor(
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {


    this.language = this.languageService.getLanguage();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }
}
